<template>
    <div class="of-form-input">
        <label v-if="!!label" for="email" class="block ml-1 mb-1 text-xs font-medium text-gray-900">
            {{ label }}
        </label>
        <div class="relative">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none" v-if="!!prependIcon">
                <font-awesome-icon :icon="['fas', prependIcon]" :style="{ color: '#a0a0a0' }" />
            </div>
            <input :type="inputType"
                   :id="inputName"
                   :name="inputName"
                   :value="value"
                   @input="$emit('input', $event.target.value)"
                   :disabled="submitting ? 'disabled' : null"
                   :dusk="dusk"
                   :required="required"
                   class="block bg-white border border-gray-200 text-gray-900 text-sm rounded-md block w-full p-1.5 placeholder:italic"
                   :class="{ 'border-red-500 focus:border-red-500 focus:ring-red-500': !!hasError, 'ps-10': !!prependIcon }"
                   :placeholder="placeholder"
                   v-bind="$attrs"
            >
        </div>
        <p class="my-2 text-xs text-red-500" v-if="!!hasError" v-html="error" />
    </div>
</template>
<script>
import { required } from '../../../../../webapp/validations';

export default {
    name: 'OFFormInput',
    props: {
        inputName: {
            type: String,
            default: ''
        },
        dusk: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        inputType: {
            type: String,
            default: 'text'
        },
        submitting: {
            type: Boolean,
            default: false
        },
        hasError: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        prependIcon: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: null
        }
    }
};
</script>
<style lang="scss" scoped>
@import "~styles/_variables";
.of-form-input {
    input:focus,
    input:focus-visible {
        outline: none !important;
        box-shadow: none !important;
    }
    input {
        color: $primary-color-dark;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/formInput.vue